import { DIALOG_DATA, DialogModule, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

export interface ConfirmDialogData {
  title: string;
  message: string;
  cancelBtnText?: string;
  okBtnText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [DialogModule, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  private readonly dialogRef = inject(DialogRef);
  public data = inject<ConfirmDialogData>(DIALOG_DATA);

  onNoClick() {
    this.dialogRef.close();
  }

  onAccept() {
    this.dialogRef.close('accept');
  }
}
